module.exports = __webpack_public_path__ + "media/svg/usa-today-32cb0613.svg";